import { Injectable } from '@angular/core';

@Injectable()
export class MenuService {

  constructor() { }

  getMenu(): Array<any> {
    const menu = [
      { name: 'login', path: './login', children: [] },
      { name: 'home', path: '/', children: [] },
      { name: 'home', path: './home', children: [] },
      { name: 'metrics', path: './metrics', children: [] },
      { 
        name: 'Clients', 
        path: './clients', 
        children: [
          /* { 
            name: 'create client', 
            path: './create', 
            children: [] 
          }, */
          { 
            name: 'Client Hub',//localStorage.getItem('clientSpouseFullName') ? localStorage.getItem('clientSpouseFullName'): 'Client Hub', 
            path: './edit', 
            children: [
              //Healthcare
              { 
                name: 'Healthcare Illustration', 
                path: './healthcare', 
                children: [
                  { 
                    name: 'Report Types', 
                    path: './options', 
                    children: [
                      { 
                        name: 'On Screen', 
                        path: './hc', 
                        children: [] 
                      },
                      { 
                        name: 'Quick', 
                        path: './hcq', 
                        children: [] 
                      }
                    ] 
                  }
                ] 
              },
              //Long-Term Care
              { 
                name: 'Long-Term Care Illustration', 
                path: './long-term-care', 
                children: [
                  { 
                    name: 'Report Types', 
                    path: './options', 
                    children: [
                      { 
                        name: 'On Screen', 
                        path: './ltc', 
                        children: [] 
                      },
                      { 
                        name: 'Quick', 
                        path: './ltcq', 
                        children: [] 
                      }
                    ] 
                  }
                ] 
              },
              //Social Security
              { 
                name: 'Social Security Illustration', 
                path: './social-security', 
                children: [
                  { 
                    name: 'Report Types', 
                    path: './options', 
                    children: [
                      { 
                        name: 'On Screen', 
                        path: './ss', 
                        children: [] 
                      },
                      { 
                        name: 'Quick', 
                        path: './ssq', 
                        children: [] 
                      }
                    ] 
                  }
                ] 
              },
              //Medicare Means Testing
              { 
                name: 'Medicare Means Testing Illustration', 
                path: './medicare-means-testing', 
                children: [
                  { 
                    name: 'Report Types', 
                    path: './options', 
                    children: [     
                      { 
                        name: 'On Screen', 
                        path: './mmtv2', 
                        children: [] 
                      },                 
                      { 
                        name: 'Quick', 
                        path: './mmtq', 
                        children: [] 
                      }
                    ] 
                  }
                ] 
              },
              //Combined HC & LTC
              { 
                name: 'Combined Illustration', 
                path: './combined', 
                children: [
                  { 
                    name: 'Report Types', 
                    path: './options', 
                    children: [
                      { 
                        name: 'On Screen', 
                        path: './combined', 
                        children: [] 
                      },
                      { 
                        name: 'Quick', 
                        path: './hcltc', 
                        children: [] 
                      }
                    ] 
                  }
                ] 
              },
            ] 
          }
        ] 
      },
      { name: 'applications', path: './applications', children: [] },
      { name: 'marketing-material', path: './marketing-material', children: [] },
      { name: 'info-center', path: './info-center', children: [] },
      { name: 'advisors', path: './advisors', children: [] },
      { name: 'organizations', path: './organizations', children: [] },
      { name: 'admin', path: './admin', children: [] },   
      { name: 'register', path: './register', children: [] },   
      { name: 'sign-up', path: './sign-up', children: [] },   
      { name: 'forgotPassword', path: './forgotPassword', children: [] }, 
      { name: 'resetPassword/:id', path: './resetPassword/:id', children: [] },   
      //{ name: 'resetPassword', path: './resetPassword', children: [{ name: 'user link', path: './', children:[]}] },   
      {
        name: 'Healthcare Express',
        path: './hc-express-questionnaire',
        children: [
          {
            name: 'Report',
            path: './hcexpress',
            children: []
          }
        ]
      },   
      { 
        name: 'Illustrations', 
        path: './reports', 
        children: [
          {
            name: 'Search Clients',
            path: './create',
            //path: './clients',
            children: [
              {
                name: 'Client Options',
                path: './illustration',
                children: [
                  { 
                    name: 'Healthcare Illustration Questions',
                    path: './hc-questionnaire',
                    children: []
                  }
                ]
              }
            ]
          },
          /* { 
            name: 'Health Care Illustration Questions',
            path: './hc-questionnaire',
            children: []
          }, */
          { 
            name: 'Long-Term Care Illustration Questions',
            path: './ltc-questionnaire',
            children: []
          },
          /* { 
            name: 'Health Care Express Report',
            path: './hc-express-questionnaire',
            children: []
          }, */
          { 
            name: 'Healthcare',
            path: './healthcare',
            children: [
              {
                name: 'Options',
                path: './options'
              }
            ]
          }
        ] 
      },
    ];

    return menu;
  }

}